import settings from '/@/core/settings';
import { PRECEON_BRAND_CODENAME } from '/@/views/recommendations/v2/steps/hybrids/hybrid-card';

/** Only the parts of a brand the hero needs; every payload shape carries these. */
export type BrandForLogo = {
    id?: number;
    name?: string;
    /** The colour mark, uploaded per brand and served by the API. */
    logo?: string;
    /** `Brand.codename` — `PC` for Preceon. */
    codename?: string;
};

/**
 * A brand's mark for the PDF hero.
 *
 * Preceon's artwork is dark and disappears against the Experto Bayer hero, so on that theme it
 * is knocked out to white. Every other brand keeps the logo the API serves — their marks are
 * already drawn to sit on a dark banner.
 *
 * The theme is read here rather than passed in: every hero that renders this sits on the same
 * banner, and a caller that forgot the prop would silently lose the knock-out.
 */
const HeroBrandLogo = ({ brand, height = '40px' }: { brand: BrandForLogo; height?: string }) => {
    if (!brand.logo) return null;

    // `settings` is untyped at its boundary, the same cast the v2 template uses to read the theme.
    const theme = (settings as unknown as { app: { theme: string } }).app.theme;
    const knockOut = theme === 'expertobayer' && brand.codename === PRECEON_BRAND_CODENAME;
    return (
        <img
            src={brand.logo}
            alt={brand.name}
            height={height}
            style={knockOut ? { filter: 'brightness(0) invert(1)' } : undefined}
        />
    );
};

export default HeroBrandLogo;
